/**
 * StageDisplay 컴포넌트
 * 레트로 게임 스타일의 스테이지 표시
 * - STAGE 1-1 형식
 * - 레트로 게임 HUD 스타일
 * - 페이지 정보 표시
 */

import React from 'react';

/**
 * StageDisplay Props
 */
interface StageDisplayProps {
  /**
   * 문제집명
   */
  workbookName?: string;

  /**
   * 현재 페이지
   */
  page: number;

  /**
   * 전체 페이지 수 (선택사항)
   */
  totalPages?: number;
}

/**
 * StageDisplay 컴포넌트
 * 스테이지 및 페이지 정보 표시
 */
export const StageDisplay: React.FC<StageDisplayProps> = ({
  workbookName,
  page,
  totalPages,
}) => {
  return (
    <div className="font-pixel">
      {/* STAGE 표시 (컴팩트) */}
      <div className="text-center">
        <div
          className="inline-block bg-[#0f380f] px-2 py-1"
          style={{
            border: '2px solid #306230',
            boxShadow: '0 2px 0 #306230',
          }}
        >
          <div className="text-[#9bbc0f] text-xs md:text-sm">
            {/* 문제집명 숨김 (모바일에서 공간 절약) */}
            {/* STAGE 표시 */}
            <div className="tracking-wide">
              STAGE {page}
              {totalPages && (
                <span className="text-[10px] md:text-xs opacity-60"> / {totalPages}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
